import { AlignmentStatus } from '../../jscaip/AI/AlignmentHeuristic';
import { CoordSet } from '../../jscaip/CoordSet';
import { SixHeuristic } from './SixHeuristic';
import { SixMove } from './SixMove';
import { SixMoveGenerator } from './SixMoveGenerator';
export class SixFilteredMoveGenerator extends SixMoveGenerator {
    heuristic = new SixHeuristic();
    getTranslations(state, legalLandings) {
        const safelyMovablePieceOrFirstOne = this.getSafelyMovablePieceOrFirstOne(state);
        return this.getTranslationsFrom(state, safelyMovablePieceOrFirstOne, legalLandings);
    }
    getSafelyMovablePieceOrFirstOne(state) {
        const allPieces = state.getPieces().reverse();
        const currentPlayer = state.getCurrentPlayer();
        const playerPieces = allPieces.get(currentPlayer).get();
        const firstPiece = playerPieces.getAnyElement().get();
        const safePieces = [];
        for (const playerPiece of playerPieces) {
            if (this.isPieceBlockingAVictory(state, playerPiece) === false) {
                safePieces.push(playerPiece);
            }
        }
        if (safePieces.length === 0) {
            return new CoordSet([firstPiece]);
        }
        else {
            return new CoordSet(safePieces);
        }
    }
    isPieceBlockingAVictory(state, playerPiece) {
        const hypotheticalState = state.switchPiece(playerPiece);
        const fakeDropMove = SixMove.ofDrop(playerPiece);
        this.heuristic.startSearchingVictorySources();
        while (this.heuristic.hasNextVictorySource()) {
            this.heuristic.currentVictorySource = this.heuristic.getNextVictorySource();
            const boardInfo = this.heuristic.searchVictoryOnly(this.heuristic.currentVictorySource, fakeDropMove, hypotheticalState);
            if (boardInfo.status === AlignmentStatus.VICTORY) {
                return true;
            }
        }
        return false;
    }
}
